export class Vendor {
    name: string;
    logoUrl: string;
    hiddenRecaptchaKey?: string;
    iconsPath: string;
    imgsPath: string;
    link: string;
    iconUrl?: string;
    links?: Object;
    additionalLinks?: Object;
    isBackOfficeEnabled: boolean;

    constructor(config: Vendor) {
        Object.assign(this, config);
    }
}

export const UTRADE = new Vendor({
    name: 'Utrade-Plus',
    logoUrl: '/assets/images/UTRADE/icon.png',
    iconUrl: '/assets/icons/UTRADE/icon.png',
    iconsPath: '/assets/icons/UTRADE/',
    imgsPath: '/assets/images/UTRADE/',
    link: 'https://utradesolutions.com/',
    links: {
        'terms_of_use': { name: 'Terms of Use', url: '' },
        'privacy_policy': { name: 'Privacy Policy', url: 'https://utradesolutions.com/PrivacyPolicyuTrade.pdf' },
        'contact_us': { name: 'Contact Us', url: 'https://utradesolutions.com/contact-us.html' },
        'more_products': { name: 'More Products from uTrade', url: 'https://utradesolutions.com/products.html' },
    },
    additionalLinks: {
        'ekyc_cove': { name: 'ekyc CoveIdentity', url: 'https://ekyc-demo.coveidentity.com' },
        'utrade_solutions': { name: 'uTrade Solutions', url: 'https://utradesolutions.com' }
    },
    isBackOfficeEnabled: false
});

export const SHAREINDIA = new Vendor({
    name: 'Share India',
    logoUrl: '/assets/images/SHAREINDIA/si_logo.svg',
    iconUrl: '/assets/images/SHAREINDIA/icon.png',
    iconsPath: '/assets/icons/UTRADE/',
    imgsPath: '/assets/images/UTRADE/',
    link: 'https://www.shareindia.com/',
    links: {
        'terms_of_use': {
            name: 'Terms of Use', url: 'https://www.shareindia.com/terms-of-use',
            description: 'Checkout our Terms of Use.', actionText: 'View Terms of Use', isClickable: true,
            icon: 'assets/icons/terms.png'
        },
        'privacy_policy': {
            name: 'Privacy Policy', url: 'https://www.shareindia.com/privacy-policy',
            description: 'Checkout our Privacy Policy.', actionText: 'View Privacy Policy', isClickable: true,
            icon: 'assets/icons/lock.png'
        },
        'refund_policy': {
            name: 'Refund Policy', url: 'https://www.shareindia.com/refund-policy',
            description: 'Checkout our Refund Policy.', actionText: 'View Refund Policy', isClickable: true,
            icon: 'assets/icons/rupee.png'
        },
        'disclaimer': {
            name: 'Disclaimer', url: 'https://www.shareindia.com/disclaimer',
            description: 'Checkout our Disclaimer Policy.', actionText: 'View Disclaimer', isClickable: true,
            icon: 'assets/icons/disclaimer.png'
        }
    },
    isBackOfficeEnabled: true
});

export const PESB = new Vendor({
    name: 'PESB',
    logoUrl: '/assets/images/PESB/icon.png',
    iconsPath: '/assets/icons/UTRADE/',
    imgsPath: '/assets/images/PESB/',
    link: '',
    isBackOfficeEnabled: false
});

export const MSE = new Vendor({
    name: 'MSE',
    logoUrl: '/assets/images/MSE/logo.png',
    iconsPath: '/assets/icons/MSE/',
    imgsPath: '/assets/images/MSE/',
    link: 'https://www.msei.in/',
    isBackOfficeEnabled: false
});

export const ESPS = new Vendor({
    name: 'ESPS',
    logoUrl: '/assets/images/ESPS/logo.png',
    iconsPath: '/assets/icons/ESPS/',
    imgsPath: '/assets/images/ESPS/',
    link: '',
    isBackOfficeEnabled: false

});

export const SKY = new Vendor({
    name: 'SKY',
    logoUrl: '/assets/images/SKY/logo.png',
    iconsPath: '/assets/icons/SKY/',
    imgsPath: '/assets/images/SKY/',
    link: '',
    links: {
        index: 'https://ekyc.skycommodities.com/index.aspx',
        partner: 'http://skycommodities.com/partner-with-us/',
        android: 'https://play.google.com/store/apps/details?id=com.wave.sky',
        ios: 'https://apps.apple.com/in/app/skymobi/id1334704547',
        phone: 'tel:0422-4700830',
        mail: 'mailto:it@skycommodities.com',
        refer: ''
    },
    isBackOfficeEnabled: false
});
